// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"2c7a40b7","136":"e992138a","224":"5ae6522a","891":"5ae6522a","950":"2f2bd413"}[chunkId] + ".chunk.css";
};